export default [
    {
        path: '/tracking',
        name: 'Tracking',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            fullWidth: true,
            fullHeight: true,
            title: 'Tracking',
        },
        components: {
            default: () => import('@views/tracking/TrackingIndex.vue'),
        },
    },
];
